import { mapState, mapGetters, mapActions } from 'vuex'

export const userMethods = mapActions('user', ['saveProfile'])

export const userComputed = {
  ...mapState('user', {
    profile: (state) => state.profile,
    access: (state) => state.access,
  }),
  ...mapGetters('user', [
    'hasProfile',
    'isChiRhosOwner',
    'isTenantOwner',
    'isTenantAdmin',
  ]),
}
